import type { QueryFunction, QueryKey } from "@tanstack/react-query";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { showErrorMessage } from "../../../actions/notification";
import { axiosInstance } from "../../../api/axiosInstance";
import store from "../../../store";
import { getAuthHeader } from "../../../tokenStorage";
import type { QueryErrorMeta } from "../models";

export const DEFAULT_STALE_TIME = 30 * 1000;
export const DEFAULT_QUERY_ERROR_MESSAGE =
  "Uh-oh! Something went wrong—try again.";

const defaultQueryFn: QueryFunction<AxiosResponse<unknown>, QueryKey> = async ({
  queryKey,
}) => {
  const url = queryKey[0];

  if (typeof url !== "string" || !url) {
    throw new Error("URL is required and cannot be empty.");
  }

  return axiosInstance.get<unknown>(url, {
    headers: getAuthHeader(),
  });
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (_error, query) => {
      const meta = query.meta as QueryErrorMeta | undefined;

      if (meta?.skipGlobalError) return;

      const message =
        typeof meta?.errorMessage === "string" && meta.errorMessage.trim()
          ? meta.errorMessage
          : DEFAULT_QUERY_ERROR_MESSAGE;

      store.dispatch(showErrorMessage(message));
    },
  }),
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: DEFAULT_STALE_TIME,
    },
  },
});
